module.exports = __webpack_public_path__ + "img/CV.Drainage.Manhole.Pre_cast_concrete_manhole,_SfA_Type_2_up_to_3m_deep.f40188cc.png";